import React, { useState } from 'react';
import {array, bool, func} from 'prop-types';

import { get, isNil } from 'lodash';

import MaterialTable from 'material-table';

import EquipmentTableRowMenu from './EquipmentTableRowMenu';

import classes from './EquipmentTable.module.css';

const EquipmentTable = ({
    equipment,
    filterBy,
    handleSelect,
    isFullArchitectAllowed,
    onToggleDeleteEquipmentEntityModal,
    showContextMenu,
    ...props
}) => {

    const getSensorCount = rowData => {
        const sensors = get(rowData, 'extendedData.sensors', []);

        const realSensors = sensors.filter(sensor => !isNil(sensor.name));

        return realSensors.length;
    };

    const sensorCountSort = (a, b) => {
        const valueA = getSensorCount(a);
        const valueB = getSensorCount(b);

        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }

        return 0;
    };

    const handleEquipmentToggle = rowData => {
        handleSelect(rowData);
    };

    const renderMenu = rowData => {
        return (
            <EquipmentTableRowMenu
                onToggleDeleteEquipmentEntityModal={onToggleDeleteEquipmentEntityModal}
                equipment={rowData}
                hidden={!isFullArchitectAllowed || !showContextMenu}
                filterBy={filterBy}
            />
        );
    };

    // Define columns prior to injecting them into component's state
    const columns = [
        {
            title: 'Name',
            field: 'name'
        },
        {
            title:      'Type',
            customSort: (a, b) => a.equipmentType.name.length - b.equipmentType.name.length,
            render:     rowData => rowData.equipmentType.name
        },
        {
            title:      'Sensor Count',
            customSort: sensorCountSort,
            render:     rowData => getSensorCount(rowData)
        },
        {
            title:  '',
            render: rowData => renderMenu(rowData)
        }
    ];

    // This is a WORK AROUND for a Material Table (as of v1.68) issue where column sort state was lost when parent
    // component's state updates. This technique is not meant for global adoption; check on the current
    // state of Material Table & determine if a solution has been introduced before copy/pasting this code.
    // That said, lifting the columns into the parent's state preserves it and prevents state change from
    // "dropping" the current column sort order.
    //
    // https://github.com/mbrn/material-table/issues/1265
    const [tableColumns] = useState(columns);

    return (
        <div className={classes.EquipmentTable}>
            <MaterialTable
                options={{
                    paging:    false,
                    showTitle: false,
                    search:    false,
                    selection: true,
                    toolbar:   false,
                    sorting:   true
                }}
                columns={tableColumns}
                data={equipment}
                onSelectionChange={handleEquipmentToggle}
            />
        </div>
    );
};

EquipmentTable.defaultProps = {
    equipment:              [],
    handleSelect:           () => {},
    isFullArchitectAllowed: true,
    onSort:                 () => {}
};

EquipmentTable.propTypes = {
    equipment:              array.isRequired,
    handleSelect:           func,
    isFullArchitectAllowed: bool,
    onSort:                 func
};

export default EquipmentTable;
